// 購物車頁：在「您的購物車」標題下方插一條「預估揀貨/出貨/抵達」進度條，讓顧客實際感受到多久會拿到貨，
// 減少不確定感。規則（已與使用者確認過）：
//   - 揀貨：訂單隔天，但跳過週六、週日、國定假日（倉庫週一~週五上班）
//   - 出貨：訂單日+3自然日（不是揀貨後3天），落在週日或國定假日就順延（物流週六有跡，只跳週日、假日）；
//     若計算出來比揀貨日還早（遠單碰上長連假），以揀貨日為基準重新順延
//   - 抵達：出貨日 + 轉運天數，同樣跳週日、假日：宅配到府 +1、超商取貨 +2（較保守）
//   - 預設顯示超商的保守估算，若顧客實際選了「宅配到府」，即時改顯示宅配的日期（監聽 AKO 按鈕的 active class）。
//
// 位置：插在「您的購物車」標題列下方（使用者原本要求放在 AKO 選擇器上方，後來改心意要移到這裡）。
//
// 國定假日清單是 2026（115年）行政院人事行政總處公布的辦公日曆表，每年都會變，到了 2027 年初需要更新這份名單（否則跨年計算會漏掉新年度的國定假日）。
//
// 重要：這支 script 用 MutationObserver 監聽整個頁面（因為 AKO 按鈕的 active class 會動態切換，需要即時反應），
// 所以寫入 DOM 之前一定要先比對值有沒有變，沒變就不寫，否則自己寫 DOM 會觸發自己的 observer、形成無限回饏把頁面卡死（這個浞已經實際踩過一次，當時頁面卡住不動）。
(function () {
  var TW_HOLIDAYS = [
    '2026-01-01',
    '2026-02-14', '2026-02-15', '2026-02-16', '2026-02-17', '2026-02-18', '2026-02-19', '2026-02-20', '2026-02-21', '2026-02-22',
    '2026-02-27', '2026-02-28', '2026-03-01',
    '2026-04-03', '2026-04-04', '2026-04-05', '2026-04-06',
    '2026-05-01', '2026-05-02', '2026-05-03',
    '2026-06-19', '2026-06-20', '2026-06-21',
    '2026-09-25', '2026-09-26', '2026-09-27', '2026-09-28',
    '2026-10-09', '2026-10-10', '2026-10-11',
    '2026-10-24', '2026-10-25', '2026-10-26',
    '2026-12-25', '2026-12-26', '2026-12-27'
  ];
  var HOLIDAY_SET = {};
  TW_HOLIDAYS.forEach(function (d) { HOLIDAY_SET[d] = true; });

  function toKey(date) {
    var y = date.getFullYear();
    var m = String(date.getMonth() + 1).padStart(2, '0');
    var d = String(date.getDate()).padStart(2, '0');
    return y + '-' + m + '-' + d;
  }

  function isHoliday(date) {
    return !!HOLIDAY_SET[toKey(date)];
  }

  function addDays(date, n) {
    var d = new Date(date.getTime());
    d.setDate(d.getDate() + n);
    return d;
  }

  function nextWarehouseWorkday(date) {
    var d = new Date(date.getTime());
    while (d.getDay() === 0 || d.getDay() === 6 || isHoliday(d)) {
      d = addDays(d, 1);
    }
    return d;
  }

  function nextCarrierWorkday(date) {
    var d = new Date(date.getTime());
    while (d.getDay() === 0 || isHoliday(d)) {
      d = addDays(d, 1);
    }
    return d;
  }

  function formatDate(date) {
    return (date.getMonth() + 1) + '/' + date.getDate();
  }

  var HOME_DELIVERY_LABEL = String.fromCharCode(0x5b85) + String.fromCharCode(0x914d) + String.fromCharCode(0x5230) + String.fromCharCode(0x5e9c);

  function computeEta(shippingMethod) {
    var today = new Date();
    today.setHours(0, 0, 0, 0);

    var pickDate = nextWarehouseWorkday(addDays(today, 1));

    var shipRaw = addDays(today, 3);
    if (shipRaw.getTime() < pickDate.getTime()) shipRaw = new Date(pickDate.getTime());
    var shipDate = nextCarrierWorkday(shipRaw);

    var transitDays = shippingMethod === HOME_DELIVERY_LABEL ? 1 : 2;
    var arriveDate = nextCarrierWorkday(addDays(shipDate, transitDays));

    return { pickDate: pickDate, shipDate: shipDate, arriveDate: arriveDate };
  }

  function getCurrentShippingMethod() {
    var activeBtn = document.querySelector('.akocommerce-logistics-button.active');
    if (activeBtn && activeBtn.textContent.indexOf(HOME_DELIVERY_LABEL) > -1) return HOME_DELIVERY_LABEL;
    return '超商取貨';
  }

  function buildEtaElement() {
    var wrap = document.createElement('div');
    wrap.className = 'vitaverse-delivery-eta vitaverse-delivery-eta-top';
    wrap.innerHTML =
      '<p class="vitaverse-delivery-eta-caption">預估配送時間（實際到貨時間以物流通知為準）</p>' +
      '<div class="vitaverse-delivery-eta-track">' +
        '<div class="vitaverse-delivery-eta-line"></div>' +
        '<div class="vitaverse-delivery-eta-step" data-step="pick"><span class="vitaverse-delivery-eta-dot"></span><span class="vitaverse-delivery-eta-label"><b></b>揀貨</span></div>' +
        '<div class="vitaverse-delivery-eta-step" data-step="ship"><span class="vitaverse-delivery-eta-dot"></span><span class="vitaverse-delivery-eta-label"><b></b>出貨</span></div>' +
        '<div class="vitaverse-delivery-eta-step" data-step="arrive"><span class="vitaverse-delivery-eta-dot"></span><span class="vitaverse-delivery-eta-label"><b></b>抵達</span></div>' +
      '</div>';
    return wrap;
  }

  var lastAppliedKey = '';

  function updateEtaDates(wrap) {
    var method = getCurrentShippingMethod();
    var eta = computeEta(method);
    var pickText = formatDate(eta.pickDate);
    var shipText = formatDate(eta.shipDate);
    var arriveText = formatDate(eta.arriveDate);
    var key = method + '|' + pickText + '|' + shipText + '|' + arriveText;
    if (key === lastAppliedKey) return; // 沒變就不寫 DOM，避免自己觸發自己的 MutationObserver
    lastAppliedKey = key;

    var pickB = wrap.querySelector('[data-step="pick"] b');
    var shipB = wrap.querySelector('[data-step="ship"] b');
    var arriveB = wrap.querySelector('[data-step="arrive"] b');
    if (pickB) pickB.textContent = pickText;
    if (shipB) shipB.textContent = shipText;
    if (arriveB) arriveB.textContent = arriveText;
  }

  function ensureEtaWidget() {
    var titleRow = document.querySelector('#main-cart-items h1');
    if (!titleRow) return;
    titleRow = titleRow.parentElement; // 標題跟「繼續購物」同一列的包裝層
    if (!titleRow) return;

    var existing = document.querySelector('.vitaverse-delivery-eta');
    if (existing) {
      updateEtaDates(existing);
      return;
    }
    var wrap = buildEtaElement();
    titleRow.insertAdjacentElement('afterend', wrap);
    lastAppliedKey = ''; // 新元素，強制第一次一定寫入日期
    updateEtaDates(wrap);
  }

  function init() {
    ensureEtaWidget();
    var observer = new MutationObserver(function () {
      ensureEtaWidget();
    });
    observer.observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
